'use strict';

module.exports = function(buffer, bits, offset, isBigEndian) {
  offset = offset || 0;
  var endian = !!isBigEndian ? 'BE' : 'LE';
  var method = buffer['readUInt' + bits + endian];
  return method.call(buffer, offset);
}



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/readUInt.js
// module id = 2214
// module chunks = 0